import { create } from "zustand";

/**
 * Aktualna zgoda na cookies (VP-312), trzymana POZA komponentami, bo czytają ją
 * zarówno hooki trackingowe (usePostHog, useIntercom), jak i kod spoza Reacta.
 * Źródłem prawdy jest banner (ciasteczko `cc_cookie`) — tu leży jego odbicie,
 * żeby zmiana zgody od razu przerenderowała hooki, które od niej zależą.
 */
export type ConsentSignals = {
  analytics: boolean;
  marketing: boolean;
  functional: boolean;
};

type ConsentState = ConsentSignals & {
  setSignals: (signals: ConsentSignals) => void;
};

export const useConsentStore = create<ConsentState>((set) => ({
  analytics: false,
  marketing: false,
  functional: false,
  setSignals: (signals) => set(signals),
}));
